import createIcon from '../../createIcon';

/**
 * @component @name EventAvailable
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNTMgMTIuMDZMMTUuNDcgMTFMMTAuNTkgMTUuODhMOC40NyAxMy43Nkw3LjQxIDE0LjgyTDEwLjU5IDE4TDE2LjUzIDEyLjA2Wk0xOSA0SDE4VjJIMTZWNEg4VjJINlY0SDVDMy44OSA0IDMuMDEgNC45IDMuMDEgNkwzIDIwQzMgMjEuMSAzLjg5IDIyIDUgMjJIMTlDMjAuMSAyMiAyMSAyMS4xIDIxIDIwVjZDMjEgNC45IDIwLjEgNCAxOSA0Wk0xOSAyMEg1VjlIMTlWMjBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EventAvailable = createIcon('EventAvailable', [
  [
    'path',
    {
      d: 'M16.53 12.06L15.47 11L10.59 15.88L8.47 13.76L7.41 14.82L10.59 18L16.53 12.06ZM19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V9H19V20Z',
      key: 'q6mk8x',
    },
  ],
]);

export default EventAvailable;
